import { render, staticRenderFns } from "./HwIcon.vue?vue&type=template&id=2baab362"
import script from "./HwIcon.vue?vue&type=script&lang=ts"
export * from "./HwIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports